var api = require("!../../../../style-loader@1.1.3_webpack@5.96.1_esbuild@0.25.5_webpack-cli@4.10.0_/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../css-loader@3.6.0_webpack@5.96.1_esbuild@0.25.5_webpack-cli@4.10.0_/node_modules/css-loader/dist/cjs.js!./skeleton.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);

var exported = content.locals ? content.locals : {};



module.exports = exported;